
import { cn } from "../../lib/utils";

export component Card({
    class: className,
    children,
    ...props
}) {
    <div class={cn(
      'bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm',
      className,
    )} {...props}>
        <children />
    </div>
}

export component CardHeader({
    class: className,
    children,
    ...props
}) {
    <div class={cn(
        '@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6',
        className,
    )} {...props}>
        <children />
    </div>
}

export component CardTitle({
    class: className,
    children,
    ...props
}) {
    <div class={cn('leading-none font-semibold', className)} {...props}>
        <children />
    </div>
}

export component CardDescription({
    class: className,
    children,
    ...props
}) {
    <div class={cn('text-muted-foreground text-sm', className)} {...props}>
        <children />
    </div>
}

export component CardAction({
    class: className,
    children,
    ...props
}) {
    <div class={cn(
        'col-start-2 row-span-2 row-start-1 self-start justify-self-end',
        className,
    )} {...props}>
        <children />
    </div>
}

export component CardContent({
    class: className,
    children,
    ...props
}) {
    <div class={cn('px-6', className)} {...props}>
        <children />
    </div>
}

export component CardFooter({
    class: className,
    children,
    ...props
}) {
    <div class={cn('flex items-center px-6 [.border-t]:pt-6', className)} {...props}>
        <children />
    </div>
}